import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";

export default function LatestGrid() {
  const latest = movies.slice(0, 10);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-14 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2">
            <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500 inline-block"></span>
            最新剧集推荐
          </h2>
          <p className="mt-2 text-xs md:text-sm text-foreground-500">
            精选近期热门剧集与电影，实时同步更新状态
          </p>
        </div>
        <Link
          to="/category"
          className="hidden sm:inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-accent-600 font-medium transition-colors cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {latest.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}